import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Label } from '@/components/generic';
import { UploadRequestObject } from '@/types';

type UploadRequestProps = {
  eventId: string;
  uploadRequestObject: UploadRequestObject;
  numberOfAssetSlots: number;
  numberOfAssets: number;
  uploadConfirmed?: boolean;
};

export const UploadRequest = ({
  eventId,
  uploadRequestObject,
  numberOfAssets,
  numberOfAssetSlots,
  uploadConfirmed
}: UploadRequestProps) => {
  const navigate = useNavigate();
  const [t] = useTranslation('common');

  return (
    <div
      className={`mb-[10px] flex w-full flex-row items-center justify-between gap-2.5 rounded-[5px] bg-secondary-light-gray p-2.5 ${uploadConfirmed ? 'cursor-auto' : 'cursor-pointer'}`}
      onClick={() => {
        uploadConfirmed
          ? undefined
          : navigate(`/events/${eventId}/upload-content/${uploadRequestObject.route}`);
      }}>
      <Label
        text={t(uploadRequestObject.name)}
        className={`${uploadConfirmed ? '!text-secondary-steel-blue' : '!text-primary-blue'} pl-[5px] text-xl font-semibold`}
      />
      <div className='inline-flex h-[41px] flex-col items-center justify-center gap-2.5 rounded-[5px] bg-primary-white px-[15px] py-2.5'>
        <Label
          text={`${numberOfAssets}/${numberOfAssetSlots}`}
          className={`${
            numberOfAssets >= numberOfAssetSlots && !uploadConfirmed
              ? '!text-primary-black'
              : '!text-secondary-gray'
          } !text-lg font-semibold`}
        />
      </div>
    </div>
  );
};
